import { render } from "./InputField.vue?vue&type=template&id=646212ce&ts=true"
import script from "./InputField.vue?vue&type=script&lang=ts"
export * from "./InputField.vue?vue&type=script&lang=ts"

import "./InputField.vue?vue&type=style&index=0&id=646212ce&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__